import React from 'react'

import ExploreCard from './ExploreCard';

import ImgA from '../../statics/img/a.jpg';
import ImgB from '../../statics/img/b.jpg';
import ImgC from '../../statics/img/c.jpg';

const ExploreCards = () => {
    return (
        <div className='bg-calcite-theme'>
            <div className='container flex flex-col m:flex-row items-center justify-around pb-12'>
                <ExploreCard 
                    title='View the Future'
                    backgroundImage={ImgA}
                    link='https://arcgis.com/apps/instant/media/index.html?appid=ba374715da3d4c649b1c5c59a5ee4266'
                />

                <ExploreCard 
                    title='View the Risk'
                    backgroundImage={ImgB}
                    link='https://arcgis.com/apps/instant/media/index.html?appid=4eb0da1e0aae4bd1b6691c1024fcb655'
                />

                <ExploreCard 
                    title='View the Change'
                    backgroundImage={ImgC}
                    link='https://arcgis.com/apps/instant/media/index.html?appid=4135c1e115584194b73e94bb82d3cb0e'
                />
            </div>
        </div>
    )
}

export default ExploreCards
